import { useEffect, useState } from "react";

/**
 * İşletme bilgileri — tek kaynak: Google profili, çalışma saatleri, açık/kapalı durumu.
 */

// Google işletme profili (Google Bilgi Grafiği kimliği)
export const GOOGLE_KIMLIK = "/g/11c57n80_x";
export const GOOGLE_PROFIL_URL = `https://www.google.com/search?q=${encodeURIComponent("Akkuzey Yapı Malzemeleri")}&kgmid=${encodeURIComponent(GOOGLE_KIMLIK)}`;
// Google Haritalar kaydı (CID, footer'daki gömülü haritanın 0x9b51e9e74440aff8 kimliğinin ondalık hali) — yorumlar bu sayfada
export const GOOGLE_HARITA_URL = "https://www.google.com/maps?cid=11191983728484200440";

// Çalışma saatleri (İstanbul saati). 0 = Pazar … 6 = Cumartesi; [açılış, kapanış] dakika cinsinden
const dk = (s) => {
  const [h, m] = s.split(":").map(Number);
  return h * 60 + m;
};
export const CALISMA_SAATLERI = {
  0: ["11:00", "18:30"],
  1: ["08:00", "20:00"],
  2: ["08:00", "20:00"],
  3: ["08:00", "20:00"],
  4: ["08:00", "20:00"],
  5: ["08:00", "20:00"],
  6: ["08:00", "20:00"],
};

const GUNLER = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

/** İstanbul'da şu anki gün ve dakika (ziyaretçinin saat diliminden bağımsız) */
const istanbulSimdi = (tarih = new Date()) => {
  const parcalar = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Istanbul",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(tarih);
  const al = (tip) => parcalar.find((p) => p.type === tip)?.value;
  return { gun: GUNLER[al("weekday")], dakika: (Number(al("hour")) % 24) * 60 + Number(al("minute")) };
};

/**
 * Açık/kapalı durumu:
 * { acik: true, kapanis: "20:00" }  ya da  { acik: false, acilis: "08:00", gunFarki: 0|1|… , gun: 0-6 }
 */
export const calismaDurumu = (tarih = new Date()) => {
  const { gun, dakika } = istanbulSimdi(tarih);
  const [a, k] = CALISMA_SAATLERI[gun];
  if (dakika >= dk(a) && dakika < dk(k)) return { acik: true, kapanis: k, sonSaat: dk(k) - dakika <= 60 };
  // Bugün henüz açılmadıysa bugün, değilse sonraki gün açılır
  if (dakika < dk(a)) return { acik: false, acilis: a, gunFarki: 0, gun };
  const yarin = (gun + 1) % 7;
  return { acik: false, acilis: CALISMA_SAATLERI[yarin][0], gunFarki: 1, gun: yarin };
};

/** Dakikada bir güncellenen açık/kapalı durumu */
export function useCalismaDurumu() {
  const [durum, setDurum] = useState(() => calismaDurumu());
  useEffect(() => {
    const zamanlayici = setInterval(() => setDurum(calismaDurumu()), 60 * 1000);
    return () => clearInterval(zamanlayici);
  }, []);
  return durum;
}

/** Arama motorları için yerel işletme bilgisi (schema.org HardwareStore) */
export const yerelIsletmeVerisi = (siteAdresi) => ({
  "@context": "https://schema.org",
  "@type": "HardwareStore",
  name: "Akkuzey Yapı Malzemeleri",
  url: siteAdresi,
  telephone: "+90 537 798 11 29",
  email: "akkuzey@hotmail.com",
  foundingDate: "1972",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Çırpıcı Mah. 75/2 Sk. No:109/1",
    addressLocality: "Zeytinburnu",
    addressRegion: "İstanbul",
    addressCountry: "TR",
  },
  openingHoursSpecification: [
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], opens: "08:00", closes: "20:00" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: "Sunday", opens: "11:00", closes: "18:30" },
  ],
  hasMap: GOOGLE_HARITA_URL,
  sameAs: ["https://www.instagram.com/akkuzeyinsaat/", GOOGLE_HARITA_URL],
});
